import { render, staticRenderFns } from "./goodsItem.vue?vue&type=template&id=3fca3fd8&scoped=true"
import script from "./goodsItem.vue?vue&type=script&lang=js"
export * from "./goodsItem.vue?vue&type=script&lang=js"
import style0 from "./goodsItem.vue?vue&type=style&index=0&id=3fca3fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca3fd8",
  null
  
)

export default component.exports